import {useRef} from 'react';
import COMPONENT_MAP from '../Repository/Components.js';

const AnalysisReportVariableDrillPopup=({popupCallBack,rowId,parent,userData,application})=>{
    const pageDetailRef=useRef();

    const pageCallback=async(action,args)=>{
        if(action==='preUpsertRecord'){
            callOnPageDetail('handleClickEvent',{action:'save_nopre'});
        }
        else{
            popupCallBack(action,args);
        }
    };

    const callOnPageDetail=async(callName,args)=>{
        if(pageDetailRef.current&&pageDetailRef.current[callName]){
            return await pageDetailRef.current[callName](args);
        }
    };

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                ref={pageDetailRef}
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'AnalysisReportVariableDrill'}
                entityParams={rowId?
                    ['_lang='+application.globalData.lang]:
                    ['_lang='+application.globalData.lang,'_context=parent_field_name='+parent.parent_field_name+',parent_field_value='+parent.parent_field_value]}
                file={'AnalysisReportVariableDrillPopup.js'}
                titleLabel={application.getLocale("TitleAnalysisReportVariableDrill")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={true}
            />
        ):null;
    };
    return renderPageDetail();
}
export default AnalysisReportVariableDrillPopup;
